/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * ChevronIcon
 *
 * @file ChevronIcon.jsx
 * @author Ujjwal Sana
 * @since 1.2.8
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const ChevronIcon = () => (
  <SvgIcon className="chevronIconNext" width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.9809 9.09687C11.4631 9.61993 11.4504 10.4351 10.9428 10.9427L2.94277 18.9427C2.42207 19.4634 1.57785 19.4634 1.05715 18.9427C0.536451 18.422 0.536451 17.5778 1.05715 17.0571L8.11434 9.99992L1.05715 2.94273C0.536453 2.42203 0.536454 1.57781 1.05715 1.05711C1.57785 0.536409 2.42207 0.53641 2.94277 1.05711L10.9428 9.05711C10.956 9.07034 10.9687 9.08358 10.9809 9.09687Z" fill="currentcolor" />
  </SvgIcon>
);

export default ChevronIcon;
